import React, {Component} from "react";

class Select extends Component {
  
  pleaseSelectOption = {name: 'Please select...', id: 'Please select...', value: 'Please select...'};
  
  constructor(props) {
    super(props);
    
    this.options = this.props.hasPleaseSelectOption ? [this.pleaseSelectOption, ...this.props.options] : [...this.props.options];
    
    this.state = {
      options: this.options,
      mobileWidth: this.props.mobileWidth ? this.props.mobileWidth : '100%',
      tabletWidth: this.props.tabletWidth ? this.props.tabletWidth : '50%',
      desktopWidth: this.props.desktopWidth ? this.props.desktopWidth : '200px',
      width: '',
      displayedValue: this.props.selected ? this.props.selected.name : this.options[0].name
    };
  }
  
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions);
  }
  
  static getDerivedStateFromProps(nextProps, prevState) {
    const newState = {};
    newState.options = nextProps.options;
    
    if (nextProps.hasPleaseSelectOption) {
      newState.options = [{name: 'Please select...', id: 'Please select...', value: null}, ...newState.options];
    }
    
    if (nextProps.resetOnPropsUpdate) {
      const prevOptions = nextProps.hasPleaseSelectOption ? prevState.options.filter((option, index) => {return index !== 0}) : prevState.options;
      const nextOptions = nextProps.options;
      
      if (!areEqual(prevOptions, nextOptions)) {
        newState.displayedValue = nextProps.selected ? nextProps.selected.name : (nextProps.options[0] ? newState.options[0].name : null);
        if (nextProps.selected) {
          newState.selected = nextProps.selected
        }
      }
    }
    
    return newState;
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }
  
  updateDimensions = () => {
    const screenWidth = document.documentElement.clientWidth;
    if (screenWidth < 600) {
      this.setState({
        width: this.state.mobileWidth
      })
    } else if (screenWidth >= 600 && screenWidth < 1024) {
      this.setState({
        width: this.state.tabletWidth
      })
    } else {
      this.setState({
        width: this.state.desktopWidth
      })
    }
  };
  
  handleClickEvent = (event) => {
    this.props.onChange(event);
    this.setState({
      displayedValue: event.nativeEvent.target[event.nativeEvent.target.selectedIndex].text
    });
  };
  
  render() {
    return (
      <div>
        {this.props.title ? <label className="input-label">{this.props.title}{this.props.required ? (<span className="schedules-search-superscript">*</span>) : null}</label> : <div className="input-label-placeholder"></div>}
        <div className="input-wrapper" style={{width: this.state.width}}>
          <select
            id={this.props.name}
            name={this.props.name}
            title={this.props.title}
            className="select"
            defaultValue={this.props.selected ? this.props.selected.value : null}
            onChange={this.handleClickEvent}
            onBlur={this.props.onBlur}
          >
            {this.state.options.length ? this.state.options.map((option) => {
              return <option
                key={option.key ? option.key : option.name}
                value={option.hasOwnProperty("value") ? option.value : option.name}>{option.name}
                </option>
            }) : null}
          </select>
          <div className="select-overlay">{this.state.displayedValue}</div>
        </div>
      </div>
    )
  }
}

export default Select;

const areEqual = (array1, array2) => {
  
  let isEqual;
  
  if (array1.length === array2.length) {
    array1.forEach((item, index) => {
      Object.keys(item).forEach((key) => {
        isEqual = item[key] === array2[index][key];
      })
    })
  } else {
    isEqual = false;
  }
  
  return isEqual;
};



// WEBPACK FOOTER //
// ./src/components/Select/Select.js